module.exports = __webpack_public_path__ + "img/stable_tech_Normal_ua.5e04f9a7.webp";